//system
import { Component, OnInit } from "@angular/core";
import {
  trigger,
  state,
  style,
  animate,
  transition,
} from "@angular/animations";

//services
import { RenderAndPreviewControllerService } from "../../services/render-and-preview-controller.service";
import { MapRendererService } from "../../services/map-renderer.service";
import { ClearDataService } from "../../services/clear-data.service";
import { FiltersService } from "../../services/filters.service";

//interfaces
import { PostOfficeInfo } from "src/app/interfaces/post-office-info.interface";
import { Day } from "../../interfaces/day.interface";

@Component({
  selector: "map-preview-container",
  templateUrl: "./map-preview-container.component.html",
  styleUrls: ["./map-preview-container.component.sass"],
  animations: [
    trigger("scaleWidth", [
      state(
        "wide",
        style({
          width: "0px",
        }),
      ),
      state(
        "thin",
        style({
          width: "30%",
        }),
      ),
      transition("thin => wide", [animate("500ms")]),
      transition("wide => thin", [animate("500ms")]),
    ]),
  ],
})
export class MapPreviewContainerComponent implements OnInit {
  public officesData: Array<any> = [];

  public vpzData: Array<any> = [];

  public pvpzIndexData: Array<any> = [];

  public selectedOffice: PostOfficeInfo;
  private selectedOfficeInListID: any;
  //private selectedOfficeOnMap: any;
  private currentDayNumber: number;

  constructor(
    private controller: RenderAndPreviewControllerService,
    private map: MapRendererService,
    private clear: ClearDataService,
    private filter: FiltersService,
  ) {
    const d = new Date();
    this.currentDayNumber = d.getDay();

    controller
      .getFilteredVPZOffices()
      .asObservable()
      .subscribe((newVPZOffices) => {
        if (newVPZOffices) {
          this.vpzData = newVPZOffices;

          this.pvpzIndexData = [];
        }
      });

    controller
      .getpvpzIndexSchedule()
      .asObservable()
      .subscribe((newPvpzDaraByIndex) => {
        if (newPvpzDaraByIndex) {
          this.pvpzIndexData = newPvpzDaraByIndex;
          // console.log(this.pvpzIndexData);
          this.vpzData = [];
        }
      });

    controller
      .getFilteredOfficesAndScadulesSubject()
      .asObservable()
      .subscribe((newOffices) => {
        if (newOffices) {
          for (let customOffice of newOffices) {
            if (customOffice.schedule) {
              // console.log(newOffices);

              if (customOffice.schedule.length > 7) {
                let multipleObjectsSchedule = customOffice.schedule.map(
                  (item) => {
                    return {
                      DAYOFWEEK_UA: item.DAYOFWEEK_UA,
                      DAYOFWEEK_NUM: item.DAYOFWEEK_NUM,
                      TFROM: item.TFROM,
                      TTO: item.TTO,
                    };
                  },
                );

                const fixedSchedule = this.hasDuplicates(
                  multipleObjectsSchedule,
                );

                customOffice.schedule = fixedSchedule;
              }
            }
          }

          if (newOffices.length === 1) {
            this.selectedOffice = newOffices[0];

            this.vpzData = [];
            this.pvpzIndexData = [];
          } else {
            this.selectedOffice = null;
          }
          this.officesData = newOffices;
        }
      });

    controller
      .getSelectedOfficeDataSubject()
      .asObservable()
      .subscribe(
        (newData: {
          officeChoosenFromList: PostOfficeInfo;
          officeChoosenOnMap: any;
          scaledUpMarkerFromList: any;
          scaledUpMarkerFromMap: any;
        }) => {
          if (newData) {
            if (newData.officeChoosenFromList) {
              //this.selectedOfficeInListID = newData.officeChoosenFromList.ID; // for grey style // deleted
              this.selectedOffice = newData.officeChoosenFromList;
            } else {
              // this.selectedOfficeInListID = null
            }

            if (newData.officeChoosenOnMap) {
              //this.selectedOffice = newData.officeChoosenOnMap[0];
              //this.selectedOfficeInListID = newData.officeChoosenOnMap.ID;
              this.selectedOffice = newData.officeChoosenOnMap;
            }
          }
        },
      );

    this.clear
      .getClearSubject()
      .asObservable()
      .subscribe(
        (whatToClear: {
          Map: boolean;
          Dropdown: boolean;
          previewList: boolean;
          previewSelected: boolean;
          clearMapMessage: boolean;
        }) => {
          if (whatToClear) {
            if (whatToClear.previewList) {
              this.officesData = [];
              this.selectedOffice = null;
            }
            if (whatToClear.previewSelected) {
              this.selectedOffice = null;
            }
          }
        },
      );
  } // constructor

  ngOnInit() {}

  public focusOnOffice(office: PostOfficeInfo) {
    this.map.FocusAtSpecialOfficeFromList(office);
    this.controller.setOfficeChoosenFromList(office);
  }

  public returnToOfficesList() {
    this.selectedOffice = null;
    this.map.deleteScaledUpMarker();
    this.controller.setSelectedOfficeData({
      officeChoosenFromList: null,
      officeChoosenOnMap: null,
      scaledUpMarkerFromList: null,
      scaledUpMarkerFromMap: null,
    });
  }

  public getCurrentDayNumber() {
    return this.filter.getCurrentDayNumber();
  }

  public isOpenedNow(wF, wT, bF = null, bT = null) {
    return this.filter.isOfficeOpenedNow(wF, wT, bF, bT);
  }

  public isCurrentDayByUserTime(day: Day) {
    return day
      ? Number.parseInt(day.DAYOFWEEK_NUM) == this.currentDayNumber
      : false;
  }

  public isOpenedNowBySchadule(schadule: Array<any>): boolean {
    return this.filter.isOpenedNowBySchadule(schadule);
  }

  public isBreakTimeNowBySchadule(schadule: Array<any>): boolean {
    return this.filter.isBreakTimeNowBySchadule(schadule);
  }

  public string01ToBoolean(str: string) {
    return Number.parseInt(str.trim()) === 1;
  }

  public string10ToBoolean(str: string) {
    return Number.parseInt(str.trim()) === 0;
  }

  public hasDuplicates(arr) {
    return arr.reduce(
      function (p, c) {
        var idx = [c.DAYOFWEEK_UA, c.TFROM, c.TTO].join("|");

        if (p.temp.indexOf(idx) === -1) {
          p.out.push(c);
          p.temp.push(idx);
        }

        return p;
      },
      {
        temp: [],
        out: [],
      },
    ).out;
  }
  //  NEW FUNCTION
  public getOfficeTypeText(office: PostOfficeInfo): string {
    if (!office) return "";

    if (
      office.IS_POSHTOMAT === "1" ||
      office.IS_PUDO === "1" ||
      office.CARGO === "1"
    ) {
      return office.TYPE_LONG || "";
    }

    if (office.TYPE_ACRONYM === "ПВ" || office.TYPE_ACRONYM === "ПВПЗ") {
      return "Пересувне відділення";
    }

    if (office.TYPE_ACRONYM === "СВ") {
      return "Сільське відділення";
    }

    if (office.TYPE_ACRONYM === "МВ") {
      return "Міське відділення";
    }

    return office.TYPE_LONG || "Відділення зв'язку";
  }

  public getAddressNote(office: PostOfficeInfo): string | null {
    if (!office) return null;

    const note = office.ADDRESS_NOTE;
    const isPudoOrPoshtomat = office.IS_PUDO === "1" || office.IS_POSHTOMAT === "1";

    if (isPudoOrPoshtomat && note && note !== "0") {
      return note;
    }

    return null;
  }
}
